import { enumID2Name } from 'common/CommonConstants';
import { CoreInstanceType } from 'core/CoreInstanceConstants';

export enum Product {
  //DEPLOYMENT = 5000,
  STORAGE = 6000,
  INSTANCE_XSMALL = 7000,
  INSTANCE_SMALL = 7001,
  INSTANCE_MEDIUM = 7002,
  INSTANCE_LARGE = 7003,
  INSTANCE_XLARGE = 7004,
}

export const productConstantName = enumID2Name<Product>(Product);

const productSettings = {
  //[Product.DEPLOYMENT]: { name: 'Deployment', productID: Product.DEPLOYMENT, sortOrder: 100 },
  [Product.STORAGE]: { name: 'Storage', productID: Product.STORAGE, sortOrder: 300 },
  [Product.INSTANCE_XSMALL]: { name: 'Instance XS', productID: Product.INSTANCE_XSMALL, sortOrder: 200 },
  [Product.INSTANCE_SMALL]: { name: 'Instance S', productID: Product.INSTANCE_SMALL, sortOrder: 210 },
  [Product.INSTANCE_MEDIUM]: { name: 'Instance M', productID: Product.INSTANCE_MEDIUM, sortOrder: 220 },
  [Product.INSTANCE_LARGE]: { name: 'Instance L', productID: Product.INSTANCE_LARGE, sortOrder: 230 },
  [Product.INSTANCE_XLARGE]: { name: 'Instance XL', productID: Product.INSTANCE_XLARGE, sortOrder: 240 },
};

export const getProductSettings = (product: Product) => {
  return productSettings[product];
};

export type AccountingReportItem = {
  deploymentID: number;
  accountID: number;
  productID: Product;
  amount: number;
  timeStart: string;
  timeEnd: string | null;
  itemTimeStart: string;
  itemTimeEnd: string;
  durationSeconds: number;
  itemPricePerSecond: number;
  itemPricePerMonth: number;
  price: number;
};

export type DeploymentRun = {
  timeStart: string;
  timeEnd: string | null;
  coreInstanceTypeID: CoreInstanceType;
};
export type StorageRun = {
  timeStart: string;
  timeEnd: string | null;
  storageSizeGiB: number;
};
export type DeploymentStats = {
  deploymentID: number;
  accountID: number;
  timeCreate: string | null;
  coreRuns: DeploymentRun[];
  storageRuns: StorageRun[];
};

export type AccountingItem = {
  productID: Product;
  amount: number;
  durationSeconds: number;
  itemPricePerSecond: number;
  itemPricePerMonth: number;
  price: number;
};

export type AccountingDeploymentStatsMap = Map<number, DeploymentStats>;
export type AccountingItemsMap = Map<number, AccountingItem>;
